import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { BRAND_NAME } from '~/common/constants/brand';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { getUserName } from '~/utils/user';

const messages = defineMessages({
  welcomeTitle: {
    id: 'Welcome.welcomeTitle',
    defaultMessage: 'Welcome to {brandName}{name}!',
    description:
      'Welcome title with optional name. Example: name = ", John" or ""',
  },
});

export function useWelcomeTitle() {
  const intl = useIntl();
  const currentUser = useCurrentUser();
  const name = getUserName(currentUser, intl);
  return intl.formatMessage(messages.welcomeTitle, {
    name: name ? `, ${name}` : '',
    brandName: BRAND_NAME,
  });
}

export function WelcomeWorkspaceLines() {
  const currentUser = useCurrentUser();
  const subdomain = currentUser?.client_config?.sub_domain;

  return (
    <Layout direction="column" spacing={2}>
      <Text as="p">
        <FormattedMessage
          id="Welcome.workspaceInfo"
          defaultMessage="Your {brandName} workspace is <strong>{subdomain}</strong>."
          description="Message showing the workspace subdomain. Example: subdomain = 'workday'"
          values={{
            subdomain,
            brandName: BRAND_NAME,
            strong: (chunks) => <b>{chunks}</b>,
          }}
        />
      </Text>
      <Text as="p">
        <FormattedMessage
          id="Welcome.loginInstructions"
          defaultMessage="In the future, you can log in by visiting evisort.com and logging in to your workspace, or by bookmarking the current page and navigating directly to <strong>{workspaceUrl}</strong> in your browser."
          description="Instructions for future login with workspace URL. Example: workspaceUrl = 'https://acme.evisort.com/'"
          values={{
            workspaceUrl: `${window.location.origin}/${subdomain}`,
            strong: (chunks) => <b>{chunks}</b>,
          }}
        />
      </Text>
    </Layout>
  );
}
